import React, { Component } from 'react';

import { history } from '../history/history';
import { menu } from './user_menu_options';

class UserSideMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuOptions: menu(),
      show: true
    }
  };

  //Checking the active class
  activeClass = menu => {
    if (this.props.match.path === menu.link) {
      return true;
    }
    return false;
  }

  componentDidMount() {
      setTimeout(() => {
        return this.setState({show: false});
      }, 5000);
  }

  //Check submenu
  checkSubMenu= subMenuArr=> {
    let show= false;
    subMenuArr.map(subMenuObj=> {
      if (this.props.match.path === subMenuObj.link) {
        show= true;
        return show;
      }
    });
    return show;
  }

  //Return the menu options
  render() {
    let { menuOptions } = this.state;
    return (
      <div className="side_menu_wrapper" >
        <div className="logo_header" onClick={() => { history.push({ pathname: '/' }) }}>

          <div className="left-logo">
            <img src="../../assets/images/dash_logo.png" title="Click Here to Go to Home Page"/>
          </div>
          <div className="right-arrow" >
            {this.state.show ? <img className="arrow_header" title="Click Here to Go to Home Page" src="../../assets/images/go-to-home-01.gif" /> : ""}
          </div>
          <div className="clearboth"></div>
         
        </div>
        <div className="menu_item_wrapper">
          <ul className="item_wrapper">
            {menuOptions.map((menu, index) => {
              return (
                <li key= {index} className={this.activeClass(menu)? "item_inner active":
                  this.checkSubMenu(menu.subMunu)? "item_inner active": "item_inner"} >
                  <a onClick={() => { history.push(menu.link) }}>
                    <span><img src= {menu.white_image} className="white" />
                      <img src= {menu.blue_image} className="blue" /></span>
                    <span>{menu.name}</span>
                  </a>
                </li>
              )
            })}
          </ul>
        </div>
        <p className="copyright_txt">Copyright @2019 BigFM. All Rights Reserved</p>
      </div>
    )
  };
}

export default UserSideMenu;


// WEBPACK FOOTER //
// ./web/menu/UserSideMenu.jsx